// eslint-disable-next-line
const getListBySectionId = (state: any) => (section: string):Array<string> => state.lists.find((x: any) => x.section === section);

const getInitialList = (state: any):Array<string> => state.lists[0];

const getCategories = (state: any):Array<string> => {
  const catList = state.lists.map((x: any) => x.section);
  return catList;
};

export default {
  getInitialList,
  getListBySectionId,
  getCategories,
};
